import { useFDCNotificationsContext } from '../../FDCNotificationsContext'
import { CIMSTags } from 'components/CIMSTags'
import { useUserTagProps } from 'components/CIMSTags/common/UserTags/hooks/useUserTagProps'
import { CIMSTagsTag } from 'components/CIMSTags/types'
import { ApproverTagsProps } from './types'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'

const ApproverTags: React.FC<ApproverTagsProps> = ({ approvalGroup }) => {
  const help = HelpMessage.FieldDesignChanges.Notifications
  const { data } = useFDCNotificationsContext()
  const userTagProps = useUserTagProps()
  const tags = [
    ...(data?.fdcApprovalGroups ?? [])
      .filter(({ id }) => {
        if (approvalGroup) return approvalGroup.id === id
        return true
      })
      .flatMap(({ users }) => users)
      .map(userTagProps),
    ...(data?.fdcApprovalGroups ?? [])
      .filter(({ id }) => {
        if (approvalGroup) return approvalGroup.id === id
        return true
      })
      .flatMap(({ roles }) => roles)
      .map<CIMSTagsTag>(({ name, users }) => ({
        text: name,
        color: 'processing',
        tooltip: `${users.filter(({ deleted }) => !deleted).length} Users`,
      })),
  ]
  const uniqueTags = [...new Set(tags.map((t) => JSON.stringify(t)))].map(
    (s) => JSON.parse(s) as CIMSTagsTag
  )
  if (!uniqueTags.length) return null
  return (
    <CIMSSection title="Approvers" help={help.ApprovalGroupTags(approvalGroup)}>
      <CIMSTags tags={uniqueTags} />
    </CIMSSection>
  )
}

export default ApproverTags
